var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('h2',{staticClass:"headline text-break"},[_vm._t("default")],2),(_vm.props.subheader)?_c('h3',{staticClass:"caption grey--text text-capitalize"},[_vm._v(_vm._s(_vm.parent.$t(_vm.props.subheader)))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }